import React, { useState } from 'react';

interface Opinion {
  fecha: Date;
  titulo: string;
  descripcion: string;
  estrellas: number;
}

const getRelativeTime = (date: Date): string => {
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
  if (diff < 1) return 'hoy';
  if (diff === 1) return 'hace 1 día';
  if (diff < 30) return `hace ${diff} días`;
  const months = Math.floor(diff / 30);
  if (months === 1) return 'hace 1 mes';
  if (months < 12) return `hace ${months} meses`;
  const years = Math.floor(months / 12);
  return years === 1 ? 'hace 1 año' : `hace ${years} años`;
};

const Opiniones: React.FC = () => {
  const [opiniones] = useState<Opinion[]>([
    { fecha: new Date('2022-12-01'), titulo: 'Buena experiencia en El Chel', descripcion: 'Muy buena comida, barata y el servicio es muy rápido. Recomiendo ampliamente.', estrellas: 4 },
    { fecha: new Date('2021-10-15'), titulo: '100% recomendable', descripcion: 'El Chel es espectacular en todo, calidad y sazón de alimentos, personal muy calificado y amable.', estrellas: 5 },
    { fecha: new Date('2023-09-01'), titulo: 'Delicioso y rápido', descripcion: 'El servicio fue muy rápido y la comida deliciosa. Definitivamente regresaré.', estrellas: 5 },
    { fecha: new Date('2023-07-01'), titulo: 'Buen precio y calidad', descripcion: 'Precios justos y excelente sabor en todos los platillos. Altamente recomendable.', estrellas: 4 },
    { fecha: new Date('2023-12-01'), titulo: 'Me encanta', descripcion: 'La cochinita es mi favorita. El lugar está limpio y el personal es muy amable.', estrellas: 5 },
  ]);

  return (
    <section
      className="w-full py-12 px-4 text-center"
      style={{ background: 'linear-gradient(135deg, #ff6d00 0%, #e65100 50%, #068a5b 100%)' }}
    >

      <p className="text-[#ff6d00] text-base font-semibold uppercase tracking-widest mb-1">Lo que dicen de nosotros</p>
      <h2 className="text-[clamp(1.9rem,3.4vw,3rem)] font-extrabold text-white mb-2">
        Opiniones de Nuestros Clientes
      </h2>
      <div className="w-16 h-1 bg-white/40 mx-auto mb-8 rounded-full" />

      <div className="flex flex-wrap justify-center gap-5 max-w-[1100px] mx-auto">
        {opiniones.map((opinion, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl p-6 w-[200px] max-md:w-full max-md:max-w-[320px] text-left transition-all duration-300 hover:scale-105 hover:-translate-y-1 shadow-brand-xl"
          >
            <p className="text-xs text-brand-deep font-medium mb-2">{getRelativeTime(opinion.fecha)}</p>
            <h3 className="text-base text-[#05603c] font-bold mb-2 leading-snug">{opinion.titulo}</h3>
            <p className="text-sm text-[#e65100] leading-relaxed mb-3">{opinion.descripcion}</p>
            <div className="text-[#FFD700] text-lg">
              {'★'.repeat(opinion.estrellas)}
              <span className="text-gray-300">{'★'.repeat(5 - opinion.estrellas)}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Opiniones;
